<template>
  <div  ref="modalButtonNav" class="new-modal-button-nav">
    <div
    v-show="ctaSecondaryButton && showCtaSecondaryButton"
    v-tooltip="ctaSecondaryTooltip"
    class="new-modal-button-nav-container">
      <button
        @click="ctaSecondaryAction()"
        :disabled="blockCtaSecondaryButton"
        class="new-modal-button-nav-container-cta button expanded secondary"
        type="button"
        :aria-label="getStringTranslation(ctaSecondaryButton)"
        role="button"
      >
        {{ getStringTranslation(ctaSecondaryButton) }}
      </button>
    </div>
    <div
    v-show="ctaPrimaryButton && showCtaPrimaryButton"
    v-tooltip="ctaPrimaryTooltip"
    class="new-modal-button-nav-container">
      <button
        @click="ctaPrimaryAction()"
        :disabled="blockCtaPrimaryButton"
        class="new-modal-button-nav-container-cta button expanded primary"
        type="button"
        :aria-label="getStringTranslation(ctaPrimaryButton)"
        role="button"
      >
        <span class="new-modal-button-nav-container-cta-text">
          {{ getStringTranslation(ctaPrimaryButton) }}
        </span>
        <img
          v-if="ctaPrimaryButtonIconType === 'svg'"
          v-show="showIconButton"
          :src="`${assetsPath}/svg/customizer/${ ctaPrimaryButtonIconName }.svg`"
          alt=""
          class="new-modal-button-nav-container-cta-icon"
          aria-hidden="true"
        />
        <span
          v-else
          :class="`new-modal-button-nav-container-cta-icon icon icon-${ ctaPrimaryButtonIconName }`"
        ></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modalButtonNav',
  props: {
    ctaPrimaryButton: {
      type: String,
      default: ''
    },
    ctaSecondaryButton: {
      type: String,
      default: ''
    },
    ctaPrimaryButtonIconName: {
      type: String,
      default: 'icon-next'
    },
    ctaPrimaryButtonIconType: {
      type: String,
      default: 'svg'
    },
    showIconButton: {
      type: Boolean,
      default: false
    },
    showCtaSecondaryButton: {
      type: Boolean,
      default: true
    },
    blockCtaPrimaryButton: {
      type: Boolean,
      default: false
    },
    ctaPrimaryTooltip: {
      type: Object,
      default: null
    },
    showCtaPrimaryButton: {
      type: Boolean,
      default: true
    },
    ctaSecondaryTooltip: {
      type: Object,
      default: null
    },
    blockCtaSecondaryButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    },
    assetsPath() {
      return this.$store.state.endPoints.customizer.customsAssets || this.$store.state.endPoints.ugcentrypoint.customsAssets;
    },
    isApparel() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
  },
  methods: {
    getStringTranslation(key) {
      return (this.translations[key]) ? this.translations[key] : key
    },
    /**
     * @function ctaSecondaryAction
     * Method to call function from content component.
     */
    ctaSecondaryAction() {
      if (this.$listeners && this.$listeners['ctaSecondaryAction']) {
        this.$emit('ctaSecondaryAction');
      }
    },
    /**
     * @function ctaPrimaryAction
     * Method to call function from content component.
     */
    ctaPrimaryAction() {
      if (this.ctaPrimaryButton === "ugcTopBarFinish") {
        this.$store.commit('utils/SET_IS_DESIGN_TRANSFER_APPLIED', false);
      }
      if (this.$listeners && this.$listeners['ctaPrimaryAction']) {
        this.$emit('ctaPrimaryAction');
      }
    }
  }
}
</script>
